import moduleConfig from './module-config';
import netsSettings from './nets-settings';

export default angular
  .module('app.settings', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsSettings', netsSettings);
